import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlPlannerV2TravelGroupAddFieldworkerInput } from "~/__generated__";

import { PlannerV2_GetPendingChangesDocument } from "../../queries.generated";
import { PlannerV2TravelGroupAddFieldworkerDocument } from "../mutations.generated";
import { PlannerV2FieldworkersGetPlannableForVisitDocument, PlannerV2VisitGetByIdDocument } from "../queries.generated";

export default function usePlannerV2TravelGroupAddFieldworker() {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2TravelGroupAddFieldworkerDocument, {
        refetchQueries: [
            PlannerV2VisitGetByIdDocument,
            PlannerV2FieldworkersGetPlannableForVisitDocument,
            PlannerV2_GetPendingChangesDocument,
        ],
        awaitRefetchQueries: true,
    });

    const addFieldworkerToTravelGroup = useCallback(
        async (input: GqlPlannerV2TravelGroupAddFieldworkerInput) => {
            const response = await mutate({ variables: { input } });
            return response.errors === undefined;
        },
        [mutate],
    );

    return {
        addFieldworkerToTravelGroup,
        loading,
        error,
        data,
    };
}
